const CLOUDINARY_DELIVERY_HOST = 'res.cloudinary.com';

/**
 * Return one small Cloudinary delivery variant for catalog card images.
 * Non-Cloudinary, malformed and already-transformed URLs pass through unchanged.
 */
export function getCloudinaryThumbnailUrl(url, width = 300) {
  if (typeof url !== 'string' || !Number.isInteger(width) || width <= 0) return url;

  try {
    const parsed = new URL(url);
    const uploadMarker = '/image/upload/';
    if (parsed.hostname !== CLOUDINARY_DELIVERY_HOST || !parsed.pathname.includes(uploadMarker)) {
      return url;
    }

    const transform = `f_auto,q_auto,w_${width}`;
    const [prefix, suffix] = parsed.pathname.split(uploadMarker);
    if (!suffix || suffix.startsWith(`${transform}/`)) return url;

    parsed.pathname = `${prefix}${uploadMarker}${transform}/${suffix}`;
    return parsed.toString();
  } catch {
    return url;
  }
}
